// extracted by mini-css-extract-plugin
export default {"main":"styles_main__ydXdH","main2":"styles_main2__oosw1","arrow":"styles_arrow__8aSvw"};